import {Component, HostListener, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import { properties } from 'src/environments/properties';

declare let $: any;

@Component({
    selector: 'payment-modal',
    templateUrl: './payment-modal.component.html',
    styleUrls: ['./payment-modal.component.scss']
})
export class PaymentModalComponent implements OnInit {

    @Input() tenderInfo: any;
    @Input() userInfo: any;
    @Input() userEnrollmentDetails: any;
    @Input() changeCode: any;
    @Input() termsID: any;
    @Input() currentEnvironment;
    @Input() retentionPlanDiscount;
    properties = properties;

    enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
    programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

    hasTenders: boolean = false;

    public displayErrorMessage: string = '';
    public API_FAIL_ERROR_MESSAGE = this.programDisplayData?.paymentModel?.API_FAIL_ERROR_MESSAGE;
    public UNKNOWN_ERROR_MESSAGE = this.programDisplayData?.paymentModel?.UNKNOWN_ERROR_MESSAGE;

    constructor(
        private bsModalRef: BsModalRef,
        public subscriptionService: SubscriptionService) {
    }

    ngOnInit() {
        this.checkTenderInfo();
    }

    close() {
        this.bsModalRef.hide();
    }

    @HostListener('document:keydown.escape', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        let key = event.key;
        if (key === 'Escape') {
            event.preventDefault();
            this.close();
        }
    }

    checkTenderInfo() {
        if (!this.tenderInfo) {
            this.setErrorMessage();
        } else {
            this.hasTenders = true;
        }
    }

    setErrorMessage(errorCode?: string): void {
        this.displayErrorMessage = this.getMessageError(errorCode);
    }

    getMessageError = (errorCode) => {
        if (errorCode.equalsIgnoreCase("OSMS-SUBSCRIPTION-0000")) {
           
                return this.UNKNOWN_ERROR_MESSAGE;
        }
            else{
                return this.API_FAIL_ERROR_MESSAGE;
        }
    };

}
